// extracted by mini-css-extract-plugin
export default {"feedback":"CenterMobileFeedback_feedback__ogIx0"};